import React, { Suspense } from 'react'
import { motion } from "framer-motion";
import Table from './Table';
import Search from './Search';
import CountUp from 'react-countup'


function LeftSideSummary({ mapStatistic, setMapCode, modalityCheck, setClientTableExpand, setMapStatistic, data, cardData, setDistrictView, isDistrictView, mapCode, districtData, setRegionHighlighted, indiaCard,clientData }) {
    // console.log(cardData)
    return (
        <div className='p-[10px] w-full cards-main fadeInUp'>
            {/* <div className='header'> */}
            <Suspense fallback={<div />}>
                <Search setMapCode={setMapCode} setDistrictView={setDistrictView} />
            </Suspense>
            {/* </div> */}
            <Suspense fallback={<div />}>
                <div className='cards'>
                    <motion.div onClick={() => {
                        setMapStatistic('clients')
                        setClientTableExpand(prev => {
                            return { ...prev, stage: 'prospects' }
                        })
                    }}
                        className={`box prospect ${mapStatistic === 'clients' && 'prospect-click'} fadeInUp`}
                        whileHover={{
                            scale: [1, 1.1, 1.1, 1, 1],
                            rotate: [0, 0, 0, 0, 0],
                            borderRadius: ["0%", "0%", "50%", "50%", "0%"]
                        }}
                        transition={{
                            duration: 2,
                            times: [0, 0.2, 0.5, 0.8, 1],

                        }}
                    >
                        <div className='cards-min'>
                            <div>Prospects</div>
                            <div>
                                {/* {cardData?.client?.toLocaleString()} */}
                                <CountUp start={0} end={cardData?.client} duration={0.5} delay={0} />
                            </div>

                        </div>
                    </motion.div>

                    <motion.div onClick={() => {
                        setMapStatistic('onboard')
                        setClientTableExpand(prev => {
                            return { ...prev, stage: 'onboard' }
                        })
                    }}
                        className={`box onboard ${mapStatistic === 'onboard' && 'onboard-click'} fadeInUp`}
                        whileHover={{
                            scale: [1, 1.1, 1.1, 1, 1],
                            rotate: [0, 0, 0, 0, 0],
                            borderRadius: ["0%", "0%", "50%", "50%", "0%"]
                        }}
                        transition={{
                            duration: 2,
                            times: [0, 0.2, 0.5, 0.8, 1],

                        }}
                    >
                        <div className='cards-min'>
                            <div>Onboarded </div>
                            <div>
                                <CountUp start={0} end={cardData?.onboard} duration={0.5} delay={0} />
                            </div>
                        </div>
                    </motion.div>

                    <motion.div onClick={() => {
                        setMapStatistic('active')
                        setClientTableExpand(prev => {
                            return { ...prev, stage: 'active' }
                        })
                    }}
                        className={`box active ${mapStatistic === 'active' && 'active-click'} fadeInUp`}
                        whileHover={{
                            scale: [1, 1.1, 1.1, 1, 1],
                            rotate: [0, 0, 0, 0, 0],
                            borderRadius: ["0%", "0%", "50%", "50%", "0%"]
                        }}
                        transition={{
                            duration: 2,
                            times: [0, 0.2, 0.5, 0.8, 1],

                        }}
                    >
                        <div className='cards-min'>
                            <div>Active </div>
                            <div>

                                <CountUp start={0} end={cardData?.active} duration={0.5} delay={0} />
                            </div>
                        </div>
                    </motion.div>

                    <motion.div onClick={() => {
                        setMapStatistic('inactive')
                        setClientTableExpand(prev => {
                            return { ...prev, stage: 'inactive' }
                        })
                    }}
                        className={`box inactive ${mapStatistic === 'inactive' && 'inactive-click'} fadeInUp`}

                        whileHover={{
                            scale: [1, 1.1, 1.1, 1, 1],
                            rotate: [0, 0, 0, 0, 0],
                            borderRadius: ["0%", "0%", "50%", "50%", "0%"]
                        }}
                        transition={{
                            duration: 2,
                            times: [0, 0.2, 0.5, 0.8, 1],

                        }}
                    >
                        <div className='cards-min'>
                            <div>InActive</div>
                            <div>
                                {/* {cardData?.inactive?.toLocaleString()} */}
                                <CountUp start={0} end={cardData?.inactive} duration={0.5} delay={0} />
                            </div>
                        </div>
                    </motion.div>

                </div>
            </Suspense>


            <div>

                <Table setClientTableExpand={setClientTableExpand} clientData={clientData} modalityCheck={modalityCheck} indiaCard={indiaCard} setMapStatistic={setMapStatistic} setRegionHighlighted={setRegionHighlighted} data={data} setMapCode={setMapCode} isDistrictView={isDistrictView} setDistrictView={setDistrictView} mapCode={mapCode} districtData={districtData} />
            </div>


        </div>
    )
}

export default LeftSideSummary
